(function () {
    'use strict';

    angular.module("imApp").factory("textileModelCategory3LangService", ['$ihttp', function ($ihttp) {
        let service = {
            listTextileModelCategory3Languages: function (parms) {
                return $ihttp.post({
                    method: 2678,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 2679,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
